<template>
  <section v-if="pax && lang['pax_info']">
    <Title :title-name="title.PersonalDetails.titleName" :title-link="title.PersonalDetails.titleLink" />
    <div class="passenger-detail">
      <div class="container" style="margin-top: 14pt">
        <div class="row">
          <div class="col-2 sb_mobile sb_flight_takeoff"></div>
          <div v-if="curPaxInfo" class="col-10" style="font-weight: bold">
            <div>
              {{ lang['pax_info'].SFS_LANG_ROW_2 }} :<span> {{ curPaxInfo.first_name }} / {{ curPaxInfo.last_name }}</span>
            </div>
            <div>
              {{ lang['pax_info'].SFS_LANG_ROW_3 }} : <span> {{ curPaxInfo.pnr }}</span>
            </div>
          </div>
          <div class="col-12" style="margin-top: 14pt">
            {{ lang['pax_info'].SFS_LANG_ROW_11 }}
          </div>
          <div class="col-12" style="margin-top: 14pt">
            <div>
              <span>{{ lang['pax_info'].SFS_LANG_ROW_12 }}</span>
              <p class="col-12">
                {{ lang['pax_info'].SFS_LANG_ROW_4 }} :
                <span v-if="isDivReason"
                  >{{ pax.dep }}-><span style="color: red; text-decoration: line-through">{{ pax.arr }}</span> {{ pax.div }}</span
                >
                <span v-else>{{ pax.dep }}->{{ pax.arr }}</span>
              </p>
              <p class="col-12">
                {{ lang['pax_info'].SFS_LANG_ROW_5 }} :
                <span>{{ pax.flight_number }}</span>
              </p>
              <p class="col-12">
                {{ lang['pax_info'].SFS_LANG_ROW_6 }} :
                <span>{{ moment(pax.std).format('DD-MM-YYYY HH:mm:ss') }}</span>
              </p>
              <p class="col-12">
                {{ lang['pax_info'].SFS_LANG_ROW_7 }} :
                <span>{{ moment(pax.sta).format('DD-MM-YYYY HH:mm:ss') }}</span>
              </p>
              <p class="col-12">
                {{ lang['pax_info'].SFS_LANG_ROW_17 }} :
                <span style="color: red">
                  <span v-if="pax.irreg_reason">{{ lang['status_flight'][pax.irreg_reason] || pax.flight_status }}</span>
                  <span v-else>{{ lang['status_flight']['NO_IRREG'] || pax.flight_status }}</span>
                </span>
              </p>
            </div>
            <div v-if="originSchedule && originSchedule.length > 0">
              <br />
              <span>{{ lang['pax_info'].SFS_LANG_ROW_13 }}</span>
              <table class="text-center table-borderless" border="1" style="width: 100%; border: none; font-size: 11pt">
                <tr>
                  <td style="color: rgb(136, 136, 136)">{{ lang['pax_info'].SFS_LANG_ROW_18 }}</td>
                  <td style="color: rgb(136, 136, 136)">{{ lang['pax_info'].SFS_LANG_ROW_19 }}</td>
                  <td style="color: rgb(136, 136, 136)">{{ lang['pax_info'].SFS_LANG_ROW_20 }}</td>
                  <td style="color: rgb(136, 136, 136)">{{ lang['pax_info'].SFS_LANG_ROW_21 }}</td>
                  <td style="color: rgb(136, 136, 136)">{{ lang['pax_info'].SFS_LANG_ROW_22 }}</td>
                  <td style="color: rgb(136, 136, 136)">{{ lang['pax_info'].SFS_LANG_ROW_23 }}</td>
                  <td style="color: rgb(136, 136, 136)">{{ lang['pax_info'].SFS_LANG_ROW_17 }}</td>
                </tr>
                <tr v-for="(item, key) in originSchedule" :key="key">
                  <td>{{ moment(item.flight_date).format('DD MMM') }}</td>
                  <td>STD {{ moment(item.std).format('HH:mm') }}</td>
                  <td>{{ item.dep }}</td>
                  <td>{{ item.carrier }}{{ item.flight_no }}</td>
                  <td v-if="item.carrier + item.flight_no === first_flightno && isDivReason">
                    <span style="color: red">{{ item.arr }}</span> {{ pax.div }}
                  </td>
                  <td v-else>{{ item.arr }}</td>
                  <td>STA {{ moment(item.sta).format('HH:mm') }}</td>
                  <td v-if="item.carrier + item.flight_no === first_flightno" style="color: red">
                    <span v-if="pax.irreg_reason">{{ lang['status_flight'][pax.irreg_reason] || pax.flight_status }}</span>
                    <span v-else>{{ lang['status_flight']['NO_IRREG'] || pax.flight_status }}</span>
                  </td>
                  <td v-else>-</td>
                </tr>
              </table>
            </div>
            <div v-if="pax.fltref != pax.first_fltref">
              <br />
              <span>{{ lang['pax_info'].SFS_LANG_ROW_14 }}</span>
              <p class="col-12">
                {{ lang['pax_info'].SFS_LANG_ROW_4 }} :
                <span>{{ pax.rebook_flight.dep }}->{{ pax.rebook_flight.arr }}</span>
              </p>
              <p class="col-12">
                {{ lang['pax_info'].SFS_LANG_ROW_5 }} :
                <span>{{ pax.rebook_flight.carrier }}{{ pax.rebook_flight.flight_no }}</span>
              </p>
              <p class="col-12">
                {{ lang['pax_info'].SFS_LANG_ROW_6 }} :
                <span>{{ moment(pax.rebook_flight.std).format('DD-MM-YYYY HH:mm:ss') }}</span>
              </p>
              <p class="col-12">
                {{ lang['pax_info'].SFS_LANG_ROW_7 }} :
                <span>{{ moment(pax.rebook_flight.sta).format('DD-MM-YYYY HH:mm:ss') }}</span>
              </p>
            </div>
            <div v-if="pax.fltref != pax.first_fltref && newSchedule && newSchedule.length > 0">
              <br />
              <span>{{ lang['pax_info'].SFS_LANG_ROW_15 }}</span>
              <table class="text-center table-borderless" border="1" style="width: 100%; border: none; font-size: 11pt">
                <tr>
                  <td style="color: rgb(136, 136, 136)">{{ lang['pax_info'].SFS_LANG_ROW_18 }}</td>
                  <td style="color: rgb(136, 136, 136)">{{ lang['pax_info'].SFS_LANG_ROW_19 }}</td>
                  <td style="color: rgb(136, 136, 136)">{{ lang['pax_info'].SFS_LANG_ROW_20 }}</td>
                  <td style="color: rgb(136, 136, 136)">{{ lang['pax_info'].SFS_LANG_ROW_21 }}</td>
                  <td style="color: rgb(136, 136, 136)">{{ lang['pax_info'].SFS_LANG_ROW_22 }}</td>
                  <td style="color: rgb(136, 136, 136)">{{ lang['pax_info'].SFS_LANG_ROW_23 }}</td>
                  <td style="color: rgb(136, 136, 136)">{{ lang['pax_info'].SFS_LANG_ROW_17 }}</td>
                </tr>
                <tr v-for="(item, k) in newSchedule" :key="k">
                  <td>{{ moment(item.flight_date).format('DD MMM') }}</td>
                  <td>STD {{ moment(item.std).format('HH:mm') }}</td>
                  <td>{{ item.dep }}</td>
                  <td>{{ item.carrier }}{{ item.flight_no }}</td>
                  <td>{{ item.arr }}</td>
                  <td>STA {{ moment(item.sta).format('HH:mm') }}</td>
                  <td>-</td>
                </tr>
              </table>
            </div>
            <br /><span>{{ lang['pax_info'].SFS_LANG_ROW_16 }}</span>
            <p class="col-12" style="white-space: pre-line" v-html="linkify(lang['pax_info'].SFS_LANG_ROW_8)"></p>
            <router-link
              v-if="airline.lang_config && isEnabledConfig('SFS_LANG_ROW_9') && pax.params.flow_status != 0 && isEnabledInAdmin"
              :to="{ name: 'InviteTravelTogether', query: { secret: secret } }"
            >
              <div style="display: flex; align-items: center; background: #e8f7f0; color: #1e3a62; margin: 15px 0">
                <div class="" style="width: 90%; float: left; padding: 20px">
                  {{ lang['pax_info'].SFS_LANG_ROW_9 }}
                </div>
                <div style="float: right"><i class="fa fa-chevron-right fa-1x"></i></div>
              </div>
            </router-link>
            <div
              v-if="
                airline &&
                airline.params &&
                airline.params.enable_callback_function == 1 &&
                isEnabledConfig('SFS_LANG_ROW_10') &&
                airline.params.enable_class &&
                airline.params.enable_class[pax.class] == 1 &&
                airline.params.enable_callback_function_class &&
                airline.params.enable_callback_function_class[pax.class] == 1
              "
              class="called-back"
            >
              <div class="btn-called-back" @click="callBackPax()">
                <span class="icon-phone-call">
                  <i class="fas fa-phone"></i>
                </span>
                <span v-if="pax.class == 'first_class'" class="text-call-number">{{ textCallNumber }}</span>
                <span v-else class="text-call-number">
                  <a :href="`tel:${airline.telephone}`">{{ textCallNumber }}</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Title from '@/components/Title/index'
import { linkify } from '@/utils/helper'
import { mapGetters } from 'vuex'

export default {
  name: 'PersonalDetails',
  components: { Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      textCallNumber: '',
      originSchedule: [],
      newSchedule: [],
      first_flightno: '',
      isDivReason: false,
      curPaxInfo: null
    }
  },
  computed: {
    ...mapGetters({
      Flight: 'Flight/Flight'
    }),
    isEnabledInAdmin() {
      let result = false

      if (
        !_.isNull(this.airline.params.mobile_enable_travelcompanions) &&
        !_.isNull(this.airline.params.mobile_enable_travelcompanions_home)
      ) {
        result = this.airline.params.mobile_enable_travelcompanions & this.airline.params.mobile_enable_travelcompanions_home
      }

      return result
    }
  },
  watch: {
    airline: function () {
      this.initData()
    },
    pax: function () {
      this.initData()
    },
    PaxsGroup: function () {
      this.initData()
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    this.$store.dispatch('Flight/getFlight')
  },
  methods: {
    linkify,
    isEnabledConfig(key) {
      let row = _.find(this.airline.lang_config.pax_info.CONFIG, { key: key })
      return !_.isUndefined(row) ? row.enabled : false
    },
    convertSchedule(connections, type) {
      let inbound_outbound = []
      let self = this
      _.each(connections, function (d) {
        if (d['inboundconnection'] || d['outboundconnection']) {
          if (d['inboundconnection']) {
            if (Array.isArray(d['inboundconnection'])) {
              _.each(d['inboundconnection'], function (element) {
                inbound_outbound.push(element)
              })
            } else if (!Array.isArray(d['inboundconnection'])) {
              inbound_outbound.push(d['inboundconnection'])
            }
          }
          let objFlight = {}
          let flight = {}
          if (type === 'original') {
            objFlight = self.pax
          } else {
            objFlight = self.pax.rebook_flight
          }
          if (!_.isEmpty(objFlight)) {
            flight.flight_date = objFlight.flight_date
            flight.std = objFlight.std
            flight.dep = objFlight.dep
            flight.carrier = objFlight.carrier
            flight.flight_no = objFlight.flight_no
            flight.arr = objFlight.arr
            flight.div = objFlight.div
            flight.sta = objFlight.sta
            inbound_outbound.push(flight)
          }
          if (d['outboundconnection']) {
            if (Array.isArray(d['outboundconnection'])) {
              _.each(d['outboundconnection'], function (element) {
                inbound_outbound.push(element)
              })
            } else if (!Array.isArray(d['outboundconnection'])) {
              inbound_outbound.push(d['outboundconnection'])
            }
          }
        }
      })
      return inbound_outbound
    },
    initData() {
      if (!_.isEmpty(this.pax) && !_.isEmpty(this.airline) && !_.isEmpty(this.PaxsGroup)) {
        let self = this
        this.textCallNumber = _.replace(self.lang['homepage_new'].SFS_LANG_ROW_20, '<airline_name>', this.airline.name)
        if (this.pax.class != 'first_class') {
          this.textCallNumber = _.replace(self.lang['homepage_new'].SFS_LANG_ROW_19, '<airline_phone>', this.airline.telephone)
        }
        self.originSchedule = self.convertSchedule(this.pax.connections, 'original')
        self.newSchedule = self.convertSchedule(this.pax.new_connections, 'rebook')
        self.newSchedule = _.remove(self.newSchedule, function (n) {
          return n.carrier + n.flight_no !== self.pax.flight_number
        })
        self.first_flightno = this.pax.carrier + this.pax.flight_no

        // Get current passenger info
        self.curPaxInfo = self.pax
        if (self.PaxsGroup.length > 1) {
          self.curPaxInfo = _.find(self.PaxsGroup, { passenger_id: parseInt(self.pax.curPaxID) })
        }
      }
    },
    callBackPax() {
      if (this.pax.class != 'first_class') {
        return
      }
      this.$store
        .dispatch('getCallBackCustomer', { group_id: this.pax.params.group_id, secret: this.secret })
        .then((response) => {
          if (response.success) {
            this.$swal('Action completed')
          } else {
            this.$swal('Failed')
          }
        })
    }
  }
}
</script>
